"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrowdsaleAccount = void 0;
exports.decrypt = decrypt;

var _aesJs = _interopRequireDefault(require("aes-js"));

var _address = require("@ethersproject/address");

var _bytes = require("@ethersproject/bytes");

var _keccak = require("@ethersproject/keccak256");

var _pbkdf = require("@ethersproject/pbkdf2");

var _strings = require("@ethersproject/strings");

var _properties = require("@ethersproject/properties");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logger = new _logger.Logger(_version.version);

var CrowdsaleAccount = /*#__PURE__*/function (_Description) {
  _inherits(CrowdsaleAccount, _Description);

  var _super = _createSuper(CrowdsaleAccount);

  function CrowdsaleAccount() {
    _classCallCheck(this, CrowdsaleAccount);

    return _super.apply(this, arguments);
  }

  _createClass(CrowdsaleAccount, [{
    key: "isCrowdsaleAccount",
    value: function isCrowdsaleAccount(value) {
      return !!(value && value._isCrowdsaleAccount);
    }
  }]);

  return CrowdsaleAccount;
}(_properties.Description); // See: https://github.com/ethereum/pyethsaletool


exports.CrowdsaleAccount = CrowdsaleAccount;

function decrypt(json, password) {
  var data = JSON.parse(json);
  password = (0, _utils.getPassword)(password); // Ethereum Address

  var ethaddr = (0, _address.getAddress)((0, _utils.searchPath)(data, "ethaddr")); // Encrypted Seed

  var encseed = (0, _utils.looseArrayify)((0, _utils.searchPath)(data, "encseed"));

  if (!encseed || encseed.length % 16 !== 0) {
    logger.throwArgumentError("invalid encseed", "json", json);
  }

  var key = (0, _bytes.arrayify)((0, _pbkdf.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
  var iv = encseed.slice(0, 16);
  var encryptedSeed = encseed.slice(16); // Decrypt the seed

  var aesCbc = new _aesJs.default.ModeOfOperation.cbc(key, iv);

  var seed = _aesJs.default.padding.pkcs7.strip((0, _bytes.arrayify)(aesCbc.decrypt(encryptedSeed))); // This wallet format is weird... Convert the binary encoded hex to a string.


  var seedHex = "";

  for (var i = 0; i < seed.length; i++) {
    seedHex += String.fromCharCode(seed[i]);
  }

  var seedHexBytes = (0, _strings.toUtf8Bytes)(seedHex);
  var privateKey = (0, _keccak.keccak256)(seedHexBytes);
  return new CrowdsaleAccount({
    _isCrowdsaleAccount: true,
    address: ethaddr,
    privateKey: privateKey
  });
}